import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
export default (function (lang) {
  return new Promise(function (res) {
    var hm = document.createElement('script');
    hm.src = "".concat(process.env.VUE_APP_TRANSLATE, "/flash-hr-ui-pc/lang/").concat(lang, ".js?").concat(new Date().getTime());
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(hm, s);
    hm.onload = function () {
      return res();
    };
  });
});